/********** DATATABLE **********/

export const GET_BIDDING_DT = "GET_BIDDING_DT"
export const GET_BIDDING_DT_OK = "GET_BIDDING_DT_OK"
export const GET_BIDDING_DT_ERR = "GET_BIDDING_DT_ERR"
export const DO_BIDDING_DT_CLEANUP = "DO_BIDDING_DT_CLEANUP"
